/**
 * First-visit mode — tiny cross-component signal so the Layout header,
 * floating help buttons, Calendly badge, and tour stay out of the way
 * on a brand-new user's very first home screen. Set by Dashboard only.
 */
import { useEffect, useState } from "react";

let _active = false;
const EVT = "mlcn:first-visit-mode";

export function setFirstVisitMode(on) {
    if (_active === on) return;
    _active = on;
    window.dispatchEvent(new CustomEvent(EVT, { detail: on }));
}

export function useFirstVisitMode() {
    const [on, setOn] = useState(_active);
    useEffect(() => {
        const h = (e) => setOn(Boolean(e.detail));
        window.addEventListener(EVT, h);
        setOn(_active);
        return () => window.removeEventListener(EVT, h);
    }, []);
    return on;
}
